/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden[_ngcontent-%COMP%]{display:none!important}.seed-needs-alert-margin[_ngcontent-%COMP%]{margin-top:1em}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/seed-needs-upload/seed-needs-upload.component.css.shim.ngstyle.js.pre-build-optimizer.js